import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { CONFIG } from '../config';

const { FiArrowRight, FiEye, FiCheck } = FiIcons;

const Hero = ({ onPrimaryClick }) => {
  return (
    <section className="relative min-h-[95vh] flex flex-col items-center justify-center text-center px-6 pt-32 overflow-hidden">
      <div className="absolute inset-0 z-[-1] pointer-events-none">
        <div className="absolute inset-0 bg-gradient-to-b from-[#080a0d] via-transparent to-[#080a0d] z-10" />
        <div className="absolute inset-0 bg-black/40 z-10" />
        <motion.img 
          initial={{ scale: 1.1, opacity: 0 }} 
          animate={{ scale: 1, opacity: 0.12 }} 
          transition={{ duration: 2.5 }} 
          src={CONFIG.IMAGES.heroBg.url} 
          className="w-full h-full object-cover grayscale" 
          alt={CONFIG.IMAGES.heroBg.alt} 
        />
      </div>

      <motion.div 
        initial={{ opacity: 0, y: 40 }} 
        animate={{ opacity: 1, y: 0 }} 
        transition={{ duration: 1, ease: [0.16, 1, 0.3, 1] }} 
        className="max-w-5xl relative z-20"
      >
        <div className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full glass border-white/10 text-blue-400 text-[10px] font-black uppercase tracking-[0.2em] mb-12">
          <span className="relative flex h-2 w-2">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-blue-400 opacity-75"></span>
            <span className="relative inline-flex rounded-full h-2 w-2 bg-blue-500"></span>
          </span>
          Next-Gen Authority Architecture
        </div>
        
        <h1 className="text-5xl md:text-8xl font-bold mb-10 text-white font-display leading-[1.05] tracking-tight">
          {CONFIG.TAGLINE.split(' ').map((word, i) => 
            word.toLowerCase() === 'trust' || word.toLowerCase() === 'engine' ? 
            <span key={i} className="text-blue-500">{word} </span> : word + ' ' 
          )}
        </h1>

        <p className="text-xl md:text-2xl text-slate-400 mb-14 max-w-3xl mx-auto leading-relaxed font-medium">
          Premium authority landing pages and professional websites for Australian businesses. Sydney based, Australia-wide. Designed to build trust, rank locally, and convert high-value enquiries.
        </p>

        <div className="flex flex-col sm:flex-row gap-5 justify-center items-center mb-20">
          <button onClick={onPrimaryClick} className="btn-premium-primary min-w-[280px]">
            {CONFIG.PRIMARY_CTA}
            <SafeIcon icon={FiArrowRight} className="text-xl" />
          </button>
          <button 
            onClick={() => document.getElementById('samples').scrollIntoView({ behavior: 'smooth' })} 
            className="btn-premium-secondary min-w-[280px]"
          >
            <SafeIcon icon={FiEye} className="text-xl" />
            {CONFIG.SECONDARY_CTA}
          </button>
        </div>

        <div className="flex flex-wrap justify-center gap-4 md:gap-8">
          {[
            "Local SEO Architecture",
            "Authority-First Messaging",
            "Mobile-First Performance",
            "Conversion-Driven Layout"
          ].map((stat, i) => (
            <motion.div 
              key={i} 
              initial={{ opacity: 0, scale: 0.9 }} 
              animate={{ opacity: 1, scale: 1 }} 
              transition={{ delay: 0.8 + (i * 0.1) }} 
              className="flex items-center gap-2 px-4 py-2 rounded-full glass-strong border-white/5 text-[10px] font-bold uppercase tracking-widest text-slate-400"
            >
              <SafeIcon icon={FiCheck} className="text-blue-500 text-sm" />
              {stat}
            </motion.div>
          ))}
        </div>
      </motion.div>
    </section>
  );
};

export default Hero;